<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<gm-sidebar *ngIf="needFullPage" [sidebarOpen]="sidebarOpen" [user] = "user" (closeSidebar)="closeSidebar()"></gm-sidebar>
<!-- <gm-sidebar-alt [sidebarOpen]="sidebarOpen" (closeSidebar)="closeSidebar()"></gm-sidebar-alt>-->
<div *ngIf="needFullPage; else elseBlock" id="main" [ngClass]="{'sidebar-open': sidebarOpen }">
    <gm-header [sidebarOpen]="sidebarOpen" (openSidebar)="openSidebar($event)"></gm-header>
    <div class="main-container">
        <router-outlet></router-outlet>
    </div>
    <gm-footer></gm-footer>
    <div *ngIf="sidebarOpen" (click)="closeSidebar()" class="sidebar-cover"></div>
</div>

<ng-template #elseBlock><router-outlet></router-outlet></ng-template>


